import {Component, OnDestroy, OnInit} from '@angular/core';

import {Model} from "survey-core";
import {ActivatedRoute, Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {
  AddSurveyResponseRequest,
  FetchMyQuestionnairesDetailsRequest
} from "../../core/questionnaires.actions";
import {fetchQuestionnairesDetails} from "../../core/questionnaires.selectors";
import {Subject, takeUntil} from "rxjs";
import {
  QuestionnaireDetails
} from "../../models/fetch-questionnaires-list.model";
import {CommonService} from "../../../../shared/services/common.service";


@Component({
  selector: 'app-take-survey-screen',
  templateUrl: './take-survey-screen.component.html',
  styleUrls: ['./take-survey-screen.component.css']
})
export class TakeSurveyScreenComponent implements OnInit, OnDestroy {

  surveyJson = {
    elements: []
  };
  surveyModel: Model;
  title: string = ''
  description: string = ''
  surveyDetails: QuestionnaireDetails = {}
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private router: Router,
    private store: Store,
    private route: ActivatedRoute,
    private commonService: CommonService
  ) {
  }

  ngOnInit(): void {
    this.route.paramMap.pipe(takeUntil(this.onDestroy))
      .subscribe((params: any) => {
        if (params?.params?.questionnaireId) {
          this.store.dispatch(FetchMyQuestionnairesDetailsRequest({payload: {surveyId: params?.params?.questionnaireId}}));
        }
      })
    this.store.select(fetchQuestionnairesDetails)
      .pipe(takeUntil(this.onDestroy)).subscribe(details => {
      if (details.survey) {
        this.surveyDetails = details.survey
        this.title = details.survey.title;
        this.description = details.survey.description;
        if (details.survey.config && details.survey.config.length > 0) {
          this.surveyJson.elements = details.survey.config[0].elements
          const survey = new Model(this.surveyJson);
          survey.questionErrorLocation = 'bottom'
          survey.showCompletedPage = false;
          survey.onComplete.add((sender, options) => {
            this.submitUserResponse(survey)
          });
          survey.completeText = "Send Response";
          this.surveyModel = survey;
        }
      }
    });

    this.commonService
      .onNavigationEnd
      .pipe(takeUntil(this.onDestroy))
      .subscribe(d => {
        const urlParams = {
          params: this.route.snapshot.params,
          queryParams: this.route.snapshot.queryParams
        }

        const prevUrlParams = this.commonService.urlParams.getValue();
        
        if (d.isRouteChanged || JSON.stringify(prevUrlParams) !== JSON.stringify(urlParams)) {
         this.commonService.urlParams.next(urlParams);
        }
      });
  }

  submitUserResponse(survey) {
    const updatedElements: any[] = []
    this.surveyDetails.config[0].elements.forEach(element => {
      let matchFound: boolean = false
      let updatedElementData: any = {}
      if (Object.keys(survey.data).length == 0) {
        updatedElementData = {...element, value: ""}
      } else {
        Object.keys(survey.data).forEach((response, responseIndex: number) => {
          if (element.name === response) {
            matchFound = true
            updatedElementData = {...element, value: survey.data[response]}
          }
          if ((responseIndex === Object.keys(survey.data).length - 1) && !matchFound) {
            updatedElementData = {...element, value: ""}
          }
        })
      }
      updatedElements.push(updatedElementData)
    });
    const updatedConfig = {...this.surveyDetails.config[0], elements: updatedElements}
    this.surveyDetails = {...this.surveyDetails, config: [updatedConfig]}
    survey.clear(false, true)
    this.store.dispatch(AddSurveyResponseRequest({payload: {surveyId: this.surveyDetails.id, config: [updatedConfig]}}))
  }

  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
